import { useQuery } from '@tanstack/react-query';

import ProductsService from '@/services/ProductsService';

export const LIST_ORIGINAL_CATEGORIES_QUERY_KEY = ['recommendationProducts'];

export function useListOriginalCategories() {
  const { data, isFetching } = useQuery({
    queryKey: LIST_ORIGINAL_CATEGORIES_QUERY_KEY,
    queryFn: () => ProductsService.listOriginalCategories(),
  });

  return {
    categories: data,
    isLoading: isFetching,
  };
}
